import { Flex, VStack } from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CanopyTooltip from '../../CanopyTooltip/CanopyTooltip';
export const portfolioStatusColors = ['#7a9a33', '#E7B416', '#DB7B34'];
function PortfolioStatusDate({
    data,
    dataKey,
    dateFormat,
    toDateFormat,
    dataSource,
    currentDate,
    ...props
}: any) {
    const [color, setColor] = useState<string>('transparent');
    const { t } = useTranslation();
    const [formattedDate, setFormattedDate] = useState();

    useEffect(() => {
        if (dateFormat && toDateFormat) {
            const originalDate = moment(data, dateFormat);
            const date: any = originalDate.format(toDateFormat);
            currentDate = currentDate ? currentDate : moment().startOf('day');
            const diff = moment
                .duration(currentDate.diff(originalDate))
                .asDays();
            let color;
            if (dataSource === 'Datafeed') {
                color =
                    diff < 3
                        ? portfolioStatusColors[0]
                        : diff >= 3 && diff <= 7
                        ? portfolioStatusColors[1]
                        : portfolioStatusColors[2];
            } else {
                color =
                    diff < 30
                        ? portfolioStatusColors[0]
                        : diff >= 30 && diff <= 60
                        ? portfolioStatusColors[1]
                        : portfolioStatusColors[2];
            }
            setColor(color);
            setFormattedDate(date);
        }
    }, [data, dateFormat, toDateFormat, dataSource]);
    return (
        <VStack
            width="100%"
            p="6px"
            data-test="protfolio-status-date"
            minHeight="30px"
            fontSize={'13px'}
            justify="center"
            background={
                dataKey === 'latest_source_as_of' ||
                !formattedDate ||
                formattedDate === 'Invalid date'
                    ? 'transparent'
                    : color
            }
            color={
                dataKey === 'latest_source_as_of' ||
                !formattedDate ||
                formattedDate === 'Invalid date'
                    ? 'inherit'
                    : '#ffffff'
            }
            fontWeight="bold"
            alignItems="end">
            <>
                <CanopyTooltip
                    label={
                        formattedDate && formattedDate !== 'Invalid date'
                            ? formattedDate
                            : '-'
                    }
                    {...props}
                    data-test="protfolio-status-date-value"
                    textAlign={'right'}>
                    {formattedDate && formattedDate !== 'Invalid date'
                        ? formattedDate
                        : '-'}
                </CanopyTooltip>

                {dataKey === 'latest_source_as_of' && (
                    <Flex>{dataSource || t('not-available')}</Flex>
                )}
            </>
        </VStack>
    );
}
export default PortfolioStatusDate;
